import { IManagableObject } from "../../IManagableObject";
declare var moment: any;

export class ShiftViewModel implements IManagableObject {
  Id: number = 0;
  Name: string;
  StartTime: string = "08:00";
  EndTime: string = "17:00";
  Mask: number = 127;
  WorkingTime: string;

  init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.Name = data["name"];
      this.StartTime = this.msToTime(data["from"]);
      this.EndTime = this.msToTime(data["till"]);
      this.Mask = data["mask"];
    }
  }

  public msToTime(duration) {
    let minutes = Math.floor((duration / (1000 * 60)) % 60),
      hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

    let resHours = (hours < 10) ? "0" + hours : hours.toString();
    let resMinutes = (minutes < 10) ? "0" + minutes : minutes.toString();

    return resHours + ":" + resMinutes;
  }

  static fromJS(data: any): ShiftViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ShiftViewModel();
    result.init(data);
    return result;
  }

  IsChecked: boolean;
}
export class ShifCreateModel {
  Id: number = 0;
  Name: string;
  From: number;
  Till: number;
  Mask: number = 127;
  WorkingTime: string;
  constructor(data: ShiftViewModel) {
    if (data) {
      this.Id = data.Id;
      this.Name = data.Name;
      this.From = this.convertTimeToMilliseconds(data.StartTime);
      this.Till = this.convertTimeToMilliseconds(data.EndTime);
      this.Mask = data.Mask;
    }
  }

  convertTimeToMilliseconds(time: string) {
    const [hours, minutes] = time.split(":").map(Number);
    const date = new Date();
    date.setUTCHours(hours, minutes, 0, 0);
    return date.getTime();
  }

}

